// Client API frontend pour la config du rapport kilométrique hebdomadaire par email.

const BASE = "https://support.gs-group.fr/api";
const tok = () => localStorage.getItem("nexo_token");
const h = () => ({ Authorization: "Bearer " + tok() });
const hJson = () => ({ ...h(), "Content-Type": "application/json" });

async function getConfig() {
  return fetch(`${BASE}/km-rapport-config`, { headers: h() }).then(r => r.json());
}

/** @param {{enabled:boolean, destinataires:string[], jourSemaine:number, heure:string}} cfg */
async function saveConfig(cfg) {
  const r = await fetch(`${BASE}/km-rapport-config`, { method: "POST", headers: hJson(), body: JSON.stringify(cfg) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

/** Envoie immédiatement le rapport (test), sans attendre la planification. */
async function sendNow(destinataires) {
  const r = await fetch(`${BASE}/km-rapport-config/test`, { method: "POST", headers: hJson(), body: JSON.stringify({ destinataires }) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

export const kmRapportApi = { getConfig, saveConfig, sendNow };
